/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

/**
 * @nullable
 */
export type ListingDetailResponseDtoEnergyPerformanceClass = typeof ListingDetailResponseDtoEnergyPerformanceClass[keyof typeof ListingDetailResponseDtoEnergyPerformanceClass] | null;


export const ListingDetailResponseDtoEnergyPerformanceClass = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  E: 'E',
  F: 'F',
  G: 'G',
} as const;
